import ApiService from '@/core/services/api.service';

const BASE_URL = 'order-cant-serve';

const OrderCanNotServeService = {
  list(params = {}) {
    return ApiService.query(`${BASE_URL}`, { params });
  },

  detail(id) {
    return ApiService.get(`${BASE_URL}/${id}`);
  },

  create(data) {
    return ApiService.post(`${BASE_URL}`, data);
  },

  update(id, data) {
    return ApiService.put(`${BASE_URL}/${id}`, data);
  },

  delete(id) {
    return ApiService.delete(`${BASE_URL}/${id}`);
  },

  exportExcel(params = {}) {
    return ApiService.query(`${BASE_URL}/export-excel`, {
      params,
      responseType: 'blob',
    });
  },
};

export default OrderCanNotServeService;
